module.exports = __webpack_public_path__ + "static/media/mytrees-config.98d51d2b.png";